<template>
    <div class="transfer-dialog">
        <el-dialog
            :visible="transferVisible"
            width="500px"
            title="转办"
            destroy-on-close
            :close-on-click-modal='false'
            :close-on-press-escape='false'
            @close="handleClose">
            <dc-form ref='dcForm' refName="transferForm" :row="formData" :config="FIELDS"
                :col="1" @data-changed="handleFormDataChange" @submit.native.prevent
                labelWidth="100px" class="transfer-form">
                <template v-slot:form-append="{ form, itemSetting, rIndex, collapseItem, dictData }">
                    <el-form-item :label="itemSetting.label" :prop="itemSetting.prop"
                        :label-width="itemSetting.labelWidth ||'70px'">
                        <span v-if="itemSetting.prop === 'ownerName'">
                        <lots-user-select :label="form[itemSetting.prop]"
                            :config="itemSetting" :cascadeData="form"
                            @change="handleMdInputChange($event, itemSetting)"></lots-user-select>
                        </span>
                    </el-form-item>
                </template>
            </dc-form>
            <span slot="footer">
                <el-button size="mini" @click="handleClose">取 消</el-button>
                <lots-button type="primary" size="mini" @click="handleConfirm" :loading="confirmLoading">确 认</lots-button>
            </span>
        </el-dialog>
    </div>
</template>

<script>
import { ref, reactive, computed } from '@vue/composition-api';
import lotsButton from '@/components/lots/lotsButton';
import dcForm from '@/modules/mdm/components/form/Index.vue';
import lotsUserSelect from '@/components/lots/lotsUserSelect';
import { tableConfig } from './config.js';
export default {
    components: {
        lotsButton,
        dcForm,
        lotsUserSelect
    },
    props: {},
    /* eslint-disable max-lines-per-function */
    setup(props, setupContext) {
        const { emit } = setupContext;
        const formData = ref({
            ownerName: '',
            ownerCode: ''
        });
        const transferVisible = ref(false);
        const confirmLoading = ref(false);
        const config = reactive(tableConfig);
        const FIELDS = computed(() => {
            return config.fields;
        });
        const handleConfirm = () => {
            setupContext.refs.dcForm.$refs.transferForm.validate((valid) => {
                if (valid) {
                    emit('confirm', formData.value);
                }
            });
        };
        const handleFormDataChange = ({ data, form, itemSetting }) => {
            formData.value = Object.assign(formData.value, form);
            if (form.ownerCode) {
                setupContext.refs.dcForm.$refs.transferForm.clearValidate();
            }
        };
        const show = () => {
            setupContext.root.$nextTick(() => {
                transferVisible.value = true;
                formData.value = {
                    ownerName: '',
                    ownerCode: ''
                };
            });
        };
        const handleClose = () => {
            transferVisible.value = false;
            formData.value = {
                ownerName: '',
                ownerCode: ''
            };
        };
        const handleMdInputChange = (form) => {
            formData.value = Object.assign(formData.value, {
                ownerName: form.userName,
                ownerCode: form.userCode
            });
            if (form.ownerCode) {
                setupContext.refs.dcForm.$refs.transferForm.clearValidate();
            }
        };
        return {
            transferVisible,
            formData,
            FIELDS,
            confirmLoading,
            handleMdInputChange,
            handleFormDataChange,
            handleConfirm,
            handleClose,
            show
        };
    }
};
</script>
<style lang="less">
.transfer-dialog {
    .transfer-form {
        .el-form-item {
            margin-bottom: 20px;
        }
    }
}
.visit-flow-form-dialog{
    .content{
        .search-box .el-input .el-input__suffix .el-input__validateIcon.el-icon-circle-close{
            display: none;
        }
    }
}
</style>
